import { render, staticRenderFns } from "./TakingsDashlet.vue?vue&type=template&id=35ce39a6"
import script from "./TakingsDashlet.vue?vue&type=script&lang=js"
export * from "./TakingsDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports